
	frappe.templates['print_tree'] = `<!DOCTYPE html>
<html lang="en">
	<head>
		<meta charset="utf-8">
		<meta http-equiv="X-UA-Compatible" content="IE=edge">
		<meta name="viewport" content="width=device-width, initial-scale=1">
		<meta name="description" content="">
		<meta name="author" content="">
		<title>{{ title }}</title>
		<link href="{{ base_url }}/assets/frappe/css/bootstrap.css" rel="stylesheet">
		<link rel="stylesheet" type="text/css" href="{{ base_url }}{{ print_format_css_path }}">
		<style>
			{{ print_css }}
		</style>
		<style>
			/* Self-contained print styles for the row-mode tree markup.
			   This page loads no desk CSS, so colors are literal (no espresso
			   vars here) and :has() is avoided (unsupported by the old WebKit
			   in wkhtmltopdf). NOTE: this file compiles through the frappe
			   microtemplate engine, which cannot handle single quotes in
			   static text — never use apostrophes here. */
			.tree {
				font-size: 13px;
				color: #1c2126;
			}
			.tree ul {
				margin: 0;
				padding: 0;
				list-style: none;
			}
			.tree a,
			.tree-link {
				text-decoration: none;
				color: inherit;
				cursor: default;
			}
			li.tree-node {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				margin: 0;
			}
			.tree-link {
				display: flex;
				flex: 1 1 0%;
				min-width: 0;
				align-items: center;
				min-height: 26px;
				padding: 2px 8px;
			}
			/* icon slot: chevron for groups, empty for leaves (alignment) */
			.tree-link > span:first-child {
				flex: none;
				width: 20px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.tree-link > span:first-child:not(.node-parent) svg {
				display: none;
			}
			.tree-link svg {
				width: 14px;
				height: 14px;
				stroke: #74808b;
				fill: none;
				stroke-width: 1.5;
				stroke-linecap: round;
				stroke-linejoin: round;
			}
			.tree-label {
				margin-left: 4px;
				min-width: 0;
			}
			/* elbow guides — same geometry as the screen styles */
			ul.tree-children {
				flex: 1 1 100%;
				padding-left: 24px;
			}
			ul.tree-children > li.tree-node {
				position: relative;
			}
			ul.tree-children > li.tree-node::before {
				content: "";
				position: absolute;
				left: -6px;
				top: 0;
				height: 13px;
				width: 12px;
				border-left: 1px solid #d1d8dd;
				border-bottom: 1px solid #d1d8dd;
			}
			ul.tree-children > li.tree-node:not(:last-child)::after {
				content: "";
				position: absolute;
				left: -6px;
				top: 13px;
				bottom: 0;
				border-left: 1px solid #d1d8dd;
			}
			ul.tree-children > li.tree-node > .tree-link {
				margin-left: 6px;
				padding-left: 2px;
			}
			/* value column (balances) at the right edge of the row */
			li.tree-node > .balance-area {
				float: none;
				flex: none;
				margin-left: auto;
				padding: 2px 8px;
				font-variant-numeric: tabular-nums;
				white-space: nowrap;
				color: #383e42;
			}
			/* interactive chrome has no place on paper */
			.tree-node-toolbar,
			.tree-actions,
			.es-button {
				display: none;
			}
		</style>
  	</head>
	<body>
		<svg id="frappe-symbols" aria-hidden="true" style="position: absolute; width: 0; height: 0; overflow: hidden;" class="d-block" xmlns="http://www.w3.org/2000/svg">
			<symbol viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="icon-chevron-down">
				<path d="m6 9 6 6 6-6"></path>
			</symbol>

			<symbol viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="icon-chevron-right">
				<path d="m9 18 6-6-6-6"></path>
			</symbol>

			<symbol viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="icon-chevron-left">
				<path d="m15 18-6-6 6-6"></path>
			</symbol>


		</svg>
		<div class="print-format-gutter">
			{% if print_settings.repeat_header_footer %}
				<div id="footer-html" class="visible-pdf">
					{% if print_settings.letter_head && print_settings.letter_head.footer %}
						<div class="letter-head-footer">
							{{ print_settings.letter_head.footer }}
						</div>
					{% endif %}
					<p class="text-center small page-number visible-pdf">
						{{ __("Page {0} of {1}", [\`<span class="page"></span>\`, \`<span class="topage"></span>\`]) }}
					</p>
				</div>
			{% endif %}

			<div class="print-format {% if landscape %} landscape {% endif %}">
				{% if print_settings.letter_head %}
				<div {% if print_settings.repeat_header_footer %} id="header-html" class="hidden-pdf" {% endif %}>
					<div class="letter-head">{{ print_settings.letter_head.header }}</div>
				</div>
					{% endif %}
					<div class="tree tree-rows opened">
						{{ tree }}
					</div>
			</div>
		</div>
	</body>
</html>
`;
